import {
  IntegrationFilter,
  BulkUpdateIntegrationFiltersRequest,
} from '@callrail/inti/src/inti/proto/integration_filter';
import { IntegrationFilterXformer } from './integration-filter-xformer';
import protobufjs from 'protobufjs';

export class BulkUpdateIntegrationFiltersXformer {
  public toRequestProtoObj(
    companyMid: number,
    filters: any[],
    userRid: string
  ): BulkUpdateIntegrationFiltersRequest {
    return {
      companyMid,
      integrationFilters: this.buildFilters(filters),
      userRid,
      companyId: 0,
    };
  }

  public toRequestProtoBinary(
    companyMid: number,
    filters: any[],
    userRid: string
  ): Uint8Array {
    const protoObj = this.toRequestProtoObj(companyMid, filters, userRid);

    return BulkUpdateIntegrationFiltersRequest.encode(protoObj).finish();
  }

  public toRequestProtoBase64(
    companyMid: number,
    filters: any[],
    userRid: string
  ): string {
    const protoObj = this.toRequestProtoObj(companyMid, filters, userRid);

    const uint8 = BulkUpdateIntegrationFiltersRequest.encode(protoObj).finish();
    return protobufjs.util.base64.encode(uint8, 0, uint8.length);
  }

  private buildFilters(filters: any[]): IntegrationFilter[] {
    const filterXformer = new IntegrationFilterXformer();
    return filters.map((el) => {
      return filterXformer.toProtoObj(el);
    });
  }
}
